import moment from 'moment-timezone';

function date(date){
    return moment.tz(date, "America/Sao_Paulo").format('DD/MM/YY');
}

function datetime (date) {
    return moment.tz(date, "America/Sao_Paulo").format('DD/MM/YY H:mm');
}

function datetimeUtc (date) {
    return moment.utc(date).tz("America/Sao_Paulo").format('DD/MM/YY H:mm');
}

function dateDefault(date){
    return moment(date).format('DD/MM/YY');
}


export {date, datetime, datetimeUtc, dateDefault}
